// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DS0S","right":"styles_right__288sb"};